import { Module } from 'vuex'
import { RootState, DrawerState } from '@/store/types'
import { MutationTypes } from '@/store/mutation-types'

export const drawer: Module<DrawerState, RootState> = {
  namespaced: true,
  state: () => ({
    isOpen: false,
  }),
  mutations: {
    [MutationTypes.TOGGLE_DRAWER](state) {
      state.isOpen = !state.isOpen
    },
  },
  actions: {
    toggleDrawer: ({ commit }) => {
      commit(MutationTypes.TOGGLE_DRAWER)
    },
  },
}
